module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ1_2.e4b52570.svg";